import React, { useState, useEffect, createContext, useMemo, useContext } from 'react'

import { useLocation, useHistory } from "react-router-dom"

import {
    Box,
    IconButton,
    ToggleButtonGroup,
    ToggleButton,
    Button
} from '@mui/material';

import api from '../../api';
import Loading from '../Loading';
import useNotification from "../Notification";

import userPermissions from "../User/Permissions"
import { getSession } from "../../auth";

import TableIcon from '@mui/icons-material/TableChart';
import CampaignIcon from '@mui/icons-material/Campaign';
import MessageIcon from '@mui/icons-material/Message';
import ResponsiveButton from './ResponsiveButton';
import ClientsIcon from '@mui/icons-material/Groups';
import ApartmentIcon from "@mui/icons-material/Apartment"
import TableRowsIcon from "@mui/icons-material/TableRows"
import AppsIcon from "@mui/icons-material/Apps"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import NotificationAddIcon from "@mui/icons-material/NotificationAdd"

import TabButtons from './TabButtons';
import TabTables from './TabTables';

import UserPermissions from '../User/Permissions';

import moment from 'moment';

import useMediaQuery from '@mui/material/useMediaQuery';

import './styles.css'
import { QueueSocket } from '../../routes';

import isMobile from '../../utils/isMobile';
import ContactProfile from './ContactProfile';

var timeout = null

var nextGroupsUrl = null
var globalGroups = []

export const ScreenContext = createContext()

const userGroups = userPermissions()

const Crm = ({ selectedTab }) => {

    const location = useLocation()
    const history = useHistory()

    const { cache, setCache } = useContext(QueueSocket)

    const isSmallScreen = useMediaQuery('(max-width: 60rem)');
    
    const urlParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const selectedTabParam = urlParams.get("selectedTab")
    const subTab = urlParams.get("subTab")
    
    const [queues, updateQueues] = useState([])
    const [accountcode, updateAccountcode] = useState(0)
    const [enterpriseId, updateEnterpriseId] = useState(0)
    const [templates, updateTemplates] = useState([])
    const [ready, updateReady] = useState(false)
    const [clients, updateClients] = useState([])
    const [groups, updateGroups] = useState([])
    const [customFields, updateCustomFields] = useState([])
    const [settings, updateSettings] = useState([])
    const [campaigns, updateCampaigns] = useState([])
    const [originNumbers, updateOriginNumbers] = useState([])
    const [permissions, updatePermissions] = useState([])
    const [notifications, updateNotifications] = useState([])
    const [startDateTime, updateStartDateTime] = useState('')
    const [endDateTime, updateEndDateTime] = useState('')
    const [smallReload, updateSmallReload] = useState(false)
    const [selectedModel, updateSelectedModel] = useState([])
    const [selectedNumberModel, updateNumberSelectedModel] = useState([])
    const [loadingContent, setLoadingContent] = useState()
    const [loadingContacts, setLoadingContacts] = useState(false)
    const [ServerData, updateServerData] = useState({ clients: [], campaigns: [], notifications: [] })
    const [limitOffset, updateLimitOffset] = useState({ clients: [], campaigns: [], notifications: [] })
    const [filterModel, updateFilterModel] = useState({ clients: { items: [] }, campaigns: { items: [] }, notifications: { items: [] } })
    const [sortModel, updateSortModel] = useState({ clients: [], campaigns: [], notifications: [] })
    const [filtersLoaded, setFiltersLoaded] = useState(false)
    const [selectedView, setSelectedView] = useState("table")
    const [profile, setProfile] = useState(null)
    const [usersEmails, setUsersEmails] = useState([])
    const [myTeam, setMyTeam] = useState([])
    const [supervisedQueues, setSupervisedQueues] = useState([])

    const handleRefresh = async () => {
        let promise = []
        updateSmallReload(true)
        switch (selectedTab) {
            case 'clients':
                promise = getClients()
                break
            case 'notifications':
                promise = fetchNotifications(startDateTime, endDateTime)
                break
            case 'campaigns':
                promise = fetchCampaigns()
                break
            default:
                ;

        }
        await promise
        updateSmallReload(false)
    }


    const getOriginNumbers = async () => {
        if (accountcode == 0) return

        let numbers = []

        await api.get(`/api/IS/account/${accountcode}/senders/`, { timeout: 0 })
            .then((res) => {
                if (res.status == 200) {
                    numbers = res.data
                    return true;
                }
                throw res;
            })
            .catch((err) => {
                console.error(err);
            });

        // Meta numbers
        const response = await api.get(`/api/enterprises/${enterpriseId}/whatsapp/`)
        if (response.status === 200) {
            const metaNumbers = []
            response.data.forEach((each) => {
                metaNumbers.push(each.phone_number)
            })
            numbers = [...numbers, ...metaNumbers]
        }

        updateOriginNumbers(numbers)

        return true
    }

    const getClients = async (command = 'get', limit = 25, offset = 0, filter = { items: [] }, sort = []) => {

        //settings
        if (enterpriseId == 0) return
        const user = getSession();
        const enterpriseSettings = user.profile.enterprise.settings;

        //limit + offset
        let newlimit = limit
        let newoffset = offset
        if (command == 'get' && limitOffset.clients.length > 0) {
            newlimit = limitOffset.clients[0]
            newoffset = limitOffset.clients[1]
        }

        //filter
        if (command == 'filter') {
            updateFilterModel(prevState => ({ ...prevState, clients: filter }))
        }
        else {
            filter = filterModel.clients
        }

        let filterString = filter.items.map(each => {
            const columnfield = each.columnField || each.field
            const operatorValue = each.operatorValue || each.operator

            if (["is_empty", "isEmpty"].includes(operatorValue))
                return (`&${encodeURIComponent(columnfield)}__is_empty=true`)

            if (["is_not_empty", "isNotEmpty"].includes(operatorValue))
                return (`&${encodeURIComponent(columnfield)}__is_not_empty=true`)

            if (each.value) {
                let value = each.value
                let requestColumnfield = columnfield
                if (user.profile.enterprise.contact_channels && requestColumnfield === 'channels')
                    requestColumnfield = 'channels2'
                else if (['no_disturb'].includes(requestColumnfield))
                    value = each.value === 'Sim' ? 1 : 0
                else if (['notification_opt_out'].includes(requestColumnfield))
                    value = each.value === 'Sim' ? 0 : 1
                
                return (`&${encodeURIComponent(requestColumnfield)}__${operatorValue.replace('=', '|')}=${encodeURIComponent(value)}`)
            }
        }).join('')

        if ('linkOperator' in filter && filter.linkOperator == 'or')
            filterString += '&or=True'

        //sort
        if (command == 'sort') {
            updateSortModel(prevState => ({ ...prevState, clients: sort }))
        }
        else {
            sort = sortModel.clients
        }

        const sortString = sort.map(each => (`&sort=${each.field}__${each.sort}`)).join('')

        let url = `/api/enterprises/${enterpriseId}/contacts/?limit=${newlimit}&offset=${newoffset}${filterString}${sortString}`;

        setLoadingContacts(true)
        await api.get(url, { timeout: 15000 })
            .then(async (res) => {
                if (res.status === 200) {
                    updateServerData(prevState => ({ ...prevState, clients: res.data }))
                    let clientdata = res.data.results;
                    updateClients(clientdata)
                    return;
                }
                if ((res.status === 404 || res.status === 400) && user.profile.enterprise.name == 'Ativa Investimentos') {
                    useNotification(
                        'Ops!',
                        'O sistema não conseguiu identificar sua organização',
                        'danger'
                    );
                    return;
                }
                throw res;
            })
            .catch(async (err) => {
                useNotification(
                    'Ops!',
                    'Ocorreu um erro no sistema',
                    'danger'
                );
                console.error(err);
            });
        setLoadingContacts(false)

        return true
    }

    const getCustomFields = async () => {
        if (enterpriseId == 0) return

        let url = `/api/enterprises/${enterpriseId}/custom_fields/`;

        const response = await api.get(url)
        if (response.status !== 200) {
            updateCustomFields([])
            return
        }

        updateCustomFields(response.data)
        return true
    }

    const loadMoreGroups = async () => {
        if (nextGroupsUrl)
            await getGroups(nextGroupsUrl)
    }

    const getGroups = async (groupsUrl, search) => {
        if (enterpriseId == 0)
            return

        if (!groupsUrl && !search) {
            nextGroupsUrl = null
            globalGroups = []
        }

        let url
        if (groupsUrl)
            url = `/api/${groupsUrl.split('/api/')[1]}`
        else {
            url = `/api/enterprises/${enterpriseId}/contact_group/noserialize/`
            if (search !== undefined)
                url = `${url}?search=${search}`
        }

        const response = await api.get(url)

        if (response.status === 403) {
            useNotification(
                'Ops!',
                'Você não tem permissão para ver esse conteúdo',
                'danger'
            );
            updateGroups([])
            return
        }

        globalGroups = (search !== undefined) ? response.data.results : [...globalGroups, ...response.data.results]

        updateGroups(globalGroups)

        nextGroupsUrl = response.data.next

        return true
    }

    const getTemplates = async () => {
        if (enterpriseId == 0) return
        await api.get(`/api/enterprises/${enterpriseId}/templates/`, { timeout: 0 })
            .then((res) => {
                if (res.status == 200) {
                    let templates = res.data.waba_templates.filter((template) => {
                        return (template.status == 'approved' &&
                            template.language == 'pt_BR' &&
                            !template.name.includes('sample_'));
                    });
                    updateTemplates(templates);
                    return;
                }
                throw res;
            })
            .catch((err) => {
                console.error(err);
            });
        return true
    }

    const fetchNotifications = async (starttime, endtime, command = 'get', limit = 25, offset = 0, filter = { items: [] }, sort = []) => {

        let newlimit = limit
        let newoffset = offset
        if (command == 'get' && limitOffset.notifications.length > 0) {
            newlimit = limitOffset.notifications[0]
            newoffset = limitOffset.notifications[1]
        }

        if (command == 'filter')
            updateFilterModel(prevState => ({ ...prevState, notifications: filter }))
        else
            filter = filterModel.notifications

        let filterString = filter.items.map(each => {
            if (each.value)
                return (`&${each.columnField}__${each.operatorValue}=${each.value}`)
        }).join('')

        if ('linkOperator' in filter && filter.linkOperator == 'or')
            filterString += '&or=True'

        //sort
        if (command == 'sort') {
            updateSortModel(prevState => ({ ...prevState, notifications: sort }))
        }
        else {
            sort = sortModel.notifications
        }

        const sortString = sort.map(each => (`&sort=${each.field}__${each.sort}`)).join('')

        const url = `/api/enterprises/${enterpriseId}/notifications/pre_filtered/?limit=${newlimit}&offset=${newoffset}${filterString}${sortString}`;

        const Start = moment(starttime).format('YYYY-MM-DD HH:mm').toString();
        const End = moment(endtime).format('YYYY-MM-DD HH:mm').toString();

        await api.post(url, {
            start_datetime: Start,
            end_datetime: End
        }, { timeout: 0 }).then((res) => {
            if (res.status == 200) {
                updateServerData(prevState => ({ ...prevState, notifications: res.data }))
                updateNotifications(res.data.results)
                return true;
            }
            throw res;
        }).catch(async (err) => {
            console.error(err);
            useNotification(
                'Ops!',
                err.data?.message || 'Não foi possível receber os dados.',
                'danger'
            );

        });
        return true;
    }

    const fetchCampaigns = async (command = 'get', limit = 25, offset = 0, filter = { items: [] }, sort = []) => {

        let newlimit = limit
        let newoffset = offset
        if (command == 'get' && limitOffset.campaigns.length > 0) {
            newlimit = limitOffset.campaigns[0]
            newoffset = limitOffset.campaigns[1]
        }

        //filter
        if (command == 'filter') {
            updateFilterModel(prevState => ({ ...prevState, campaigns: filter }))
        }
        else {
            filter = filterModel.campaigns
        }

        let filterString = filter.items.map(each => {
            if (each.value)
                return (`&${each.columnField}__${each.operatorValue}=${each.value}`)
        }).join('')

        if ('linkOperator' in filter && filter.linkOperator == 'or')
            filterString += '&or=True'

        //sort
        if (command == 'sort') {
            updateSortModel(prevState => ({ ...prevState, campaigns: sort }))
        }
        else {
            sort = sortModel.campaigns
        }

        const sortString = sort.map(each => (`&sort=${each.field}__${each.sort}`)).join('')

        const url = `/api/enterprises/${enterpriseId}/campaign/?limit=${newlimit}&offset=${newoffset}${filterString}${sortString}`;
        const response = await api.get(url)

        const responseData = (response.status == 200 && response.data && typeof response.data === 'object')
            ? response.data
            : { results: [] }

        updateServerData(prevState => ({ ...prevState, campaigns: responseData }))
        updateCampaigns(responseData.results || [])
    }

    const initSession = async () => {
        const user = getSession();
        if (user && user.profile) {
            const enterprise = user.profile.enterprise;
            if (enterprise) {
                updateEnterpriseId(enterprise.id);
                updateAccountcode(enterprise.accountcode)
                updateSettings(enterprise.settings)
            }
            const queues_set = user.profile.queues;
            if (queues_set) {
                let user_queues = {};
                queues_set.map(queue => {
                    user_queues[queue.description] = queue.name;
                });
                updateQueues(user_queues);
            }
            return true
        }
    }


    //Substitute or add data from objNew into objOld by their id
    //Data must be in the format [{id:1, ...}, {id:2, ...}, {id:3, ...}, ...]
    // Received data must be a unique object or an array of objects.
    const subsObj = (objOld, objNew) => {
        const parsed = {}
        objOld.map(each => { parsed[each.id] = each })
        const newobj = {}
        if (Array.isArray(objNew)) {
            objNew.map(each => { newobj[each.id] = each })
            return Object.values({ ...parsed, ...newobj })
        }
        newobj[objNew.id] = objNew
        return Object.values({ ...parsed, ...newobj })
    }
    //Remove data from an array by idlist, 
    //Data must be in the format [{id:1, ...}, {id:2, ...}, {id:3, ...}, ...]
    //Received data must be in the format [1,2,3,...] or a unique integer.
    const rmvObj = (oldArr, idList) => {
        if (Array.isArray(idList)) {
            return oldArr.filter(each => !idList.includes(each.id))
        }
        return oldArr.filter(each => idList !== (each.id))
    }


    // initialize
    if (!enterpriseId) {
        initSession()
        updatePermissions(UserPermissions())
    }

    useEffect(() => {
        const crmFilters = JSON.parse(localStorage.getItem('crmFilters'))
        if (crmFilters)
            updateFilterModel(crmFilters)
        setFiltersLoaded(true)
        setProfile(null)
    }, [selectedTab])

    useEffect(() => {
        if (filtersLoaded)
            localStorage.setItem('crmFilters', JSON.stringify(filterModel))
    }, [filterModel])

    const fetchUsersEmails = async () => {
        
            const res = await api.get(`/api/enterprises/${enterpriseId}/users/get_users_emails/`)
    
            if (res.status === 200) {
                setUsersEmails(res.data)
                return
            }
        }

    const fetchMyTeam = async () => {
        if (userGroups.isSupervisor) {
            const response = await api.get(`api/users/${getSession().id}/myteam/`)
            const queues = new Set()
            if (response.status === 200 && response.data.length > 0) {
                setMyTeam(response.data[0].members_data)
                response.data[0].members_data.forEach((member) => {
                    member.profile.queues.forEach((queue) => {
                        const parts = (queue.name || "").split("_")
                        const queue_number = parts[parts.length - 1]
                        if (queue_number && queue_number.startsWith("0000"))
                            queues.add(queue.id)
                    })
                })
            }
            if (userGroups.isSupervisor)
                getSession().profile.supervised_queues.forEach((q) => queues.add(q))
            setSupervisedQueues(Array.from(queues))
        }
    }

    const memo = useMemo(async () => {
        updateReady(false)

        if (enterpriseId) {
            let startDate, endDate
            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.has("dateRange")) {
                const [start, end] = urlParams.get("dateRange").split(",")
                startDate = start
                endDate = end
            } else {
                const date = new Date()
                date.setHours(15)
                date.setMinutes(0)
                date.setSeconds(0)
                const yesterday = new Date()
                yesterday.setHours(5)
                yesterday.setMinutes(0)
                yesterday.setSeconds(0)
                startDate = yesterday.toISOString().slice(0, 19)
                endDate = date.toISOString().slice(0, 19)   
            }

            updateStartDateTime(startDate)
            updateEndDateTime(endDate)

            const promises = []
            
            if (selectedTab === "clients") {
                promises.push(getTemplates()) // TODO: remove this once all numbers have been ported to Meta
                promises.push(getGroups())
                promises.push(getClients())
                promises.push(getOriginNumbers())
                promises.push(getCustomFields())
                promises.push(fetchUsersEmails())
                promises.push(fetchMyTeam())
            }

            if (selectedTab === "enterprises") {
                promises.push(fetchMyTeam())
                promises.push(getOriginNumbers())
                promises.push(getCustomFields())
                promises.push(fetchUsersEmails())
            }

            if (selectedTab === "campaigns") {
                promises.push(getTemplates()) // TODO: remove this once all numbers have been ported to Meta
                promises.push(fetchCampaigns())
                promises.push(getOriginNumbers())
                if (urlParams.has("campaignId")) {
                    const filter = { items: [{ columnField: "campaign_id", operatorValue: "equals", value: urlParams.get("campaignId") }] }
                    promises.push(fetchNotifications(startDate, endDate, "filter", 25, 0, filter))
                } else if (urlParams.has("status")) {
                    const filter = { items: [{ columnField: 'status', operatorValue: 'is', value: urlParams.get("status") }] }
                    promises.push(fetchNotifications(startDate, endDate, "filter", 25, 0, filter))
                } else
                    promises.push(fetchNotifications(startDate, endDate))
            }

            if (selectedTab === "enterprises") {
                promises.push(getGroups())
            }

            await Promise.all(promises)

            updateReady(true)
        }
    }, [filtersLoaded, selectedTab, window.location.search])

    useEffect(() => {
        if (cache == -1) {
            if (selectedTab === "enterprises" && window.fetchEnterprises) {
                window.fetchEnterprises()
            } else {
                getClients()
            }
            getGroups()
            setCache(null)
        }
        return
    }, [cache])

    useEffect(() => {
        clearTimeout(timeout)
        checkCache()
    }, [cache])

    const checkCache = async () => {
        if (cache) {
            const res = await api.get(`/api/enterprises/${enterpriseId}/contacts/progress/${cache}/`)

            if (res.status == 200) {
                setLoadingContent(res.data)
                if (res.data?.status == 8) {
                    setLoadingContent()
                    return
                }
                timeout = setTimeout(checkCache, 1000)
                return
            }
            setLoadingContent()
        }
    }

    useEffect(() => {
        if (profile) return;

        const params = new URLSearchParams(location.search);

        const selectedTab = params.get("selectedTab");

        if (selectedTab === "contacts") {
            const selectedContact = params.get("selectedContact");

            if (!selectedContact) return;

            api
                .get(`/api/enterprises/${enterpriseId}/contacts/${selectedContact}/`)
                .then((res) => {
                    if (res.status === 200) {
                        setProfile(res.data);
                    }
                });
        }
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        const selectedTab = params.get("selectedTab");

        if (selectedTab === "contacts") {
            if (profile) {
                params.set("selectedContact", profile.id);
            } else {
                params.delete("selectedContact");
            }
        }

        const newSearch = params.toString();

        if (newSearch !== location.search.replace(/^\?/, "")) {
            history.push({
                pathname: location.pathname,
                search: newSearch,
            });
        }
    }, [profile?.id]);

    return (
        <>
            {ready && loadingContacts &&
                <Loading loading={true} />
            }
            
            {!ready
                ? <Loading loading={true} />
                : null
            }
            
            {ready ?
                <ScreenContext.Provider
                    value={{
                        updateStartDateTime, updateEndDateTime, getGroups, getCustomFields,
                        fetchCampaigns, fetchNotifications, getClients, updateClients,
                        updateReady, subsObj, rmvObj, updateCampaigns,
                        originNumbers, clients, groups, customFields, templates, queues,
                        accountcode, enterpriseId, selectedTab, permissions,
                        notifications, startDateTime, endDateTime, campaigns,
                        settings, campaigns,
                        isSmallScreen, updateGroups, updateCustomFields, selectedModel,
                        updateSelectedModel, ServerData, updateLimitOffset,
                        limitOffset, filterModel,
                        updateFilterModel, sortModel, updateSortModel, setCache, cache,
                        selectedNumberModel, updateNumberSelectedModel,
                        profile, setProfile, selectedView, usersEmails, setUsersEmails,
                        myTeam, supervisedQueues
                    }}
                >
                    <Box className="screen-wrapper">
                        <Box className={(selectedTab === "enterprises" || profile) ? "outer-Screen profile" : "outer-Screen"}>
                            <Box className="inner-Screen">
                                {selectedTab === "campaigns" && selectedTabParam === "notifications" &&
                                    <Button className="campaign-navigation-btn"
                                        onClick={() => {
                                            const params = new URLSearchParams()
                                            params.set("selectedTab", "campaigns")
                                            history.push(`${location.pathname}?${params.toString()}`)
                                        }}
                                    >
                                        <ArrowBackIcon />
                                        Campanhas
                                    </Button>
                                }
                                {selectedTab === "campaigns" && subTab === "templates" &&
                                    <Button className="campaign-navigation-btn"
                                        onClick={() => {
                                            const urlParams = new URLSearchParams()
                                            urlParams.set("selectedTab", "campaigns")
                                            history.push(`${location.pathname}?${urlParams.toString()}`)
                                        }}
                                    >
                                        <ArrowBackIcon />
                                        Campanhas
                                    </Button>
                                }
                                <Box>
                                    {! profile 
                                        ? <TabButtons /> 
                                        : <IconButton onClick={() => setProfile(null)} sx={{ padding: "0.35rem" }}><ArrowBackIcon /></IconButton>
                                    }
                                </Box>
                                {selectedTab === "campaigns" && selectedTabParam === "campaigns" && subTab !== "templates" &&
                                    <Box style={{ display: 'flex', gap: '1rem' }}>
                                        {(getSession().profile.can_create_template || userGroups.isAdmin || userGroups.isSupervisor) &&
                                            <Button className="campaign-navigation-btn"
                                                onClick={() => {
                                                    const params = new URLSearchParams()
                                                    params.set("selectedTab", "campaigns")
                                                    params.set("subTab", "templates")
                                                    history.push(`${location.pathname}?${params.toString()}`)
                                                }}
                                            >
                                                <NotificationAddIcon style={{ marginRight: '0.5rem' }} />
                                                Templates
                                                <ArrowForwardIcon />
                                            </Button>
                                        }
                                        <Button className="campaign-navigation-btn"
                                            onClick={() => {
                                                const params = new URLSearchParams()
                                                params.set("selectedTab", "notifications")
                                                history.push(`${location.pathname}?${params.toString()}`)
                                            }}
                                        >
                                            Histórico de notificações
                                            <ArrowForwardIcon />
                                        </Button>
                                    </Box>
                                }
                                {(selectedTab === "clients" && ! profile) &&
                                    <ToggleButtonGroup
                                        orientation="horizontal"
                                        value={selectedView}
                                        exclusive
                                        onChange={(event, nextView) => {
                                            if (nextView)
                                                setSelectedView(nextView)
                                        }}
                                        size="small"
                                        className="toggle-view-mode-btn"
                                    >
                                        <ToggleButton value="table" aria-label="table">
                                            <TableRowsIcon />
                                        </ToggleButton>
                                        <ToggleButton value="grid" aria-label="grid">
                                            <AppsIcon />
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                }
                            </Box>
                        </Box>
                        <Box className="table-screen" {...(profile ? { display: 'none' } : {})}>
                            <TabTables loadMoreGroups={loadMoreGroups} />
                        </Box>
                        {profile
                            ? <Box className="table-screen"><ContactProfile /></Box>
                            : null
                        }
                    </Box>
                </ScreenContext.Provider >
                : null
            }
        </>
    )
}

export default Crm
